module.exports = __webpack_public_path__ + "static/media/S (158).1cbcb50c.jpg";